export const buildChangeMeta = (editedFields, currentValues, newValues) => editedFields.map((field => {
    const isDate = newValues[field] instanceof Date && !isNaN(newValues[field]);
    return {
        field,
        oldValue: currentValues[field],
        newValue: isDate ? newValues[field].toISOString() : newValues[field]
    };
})).filter(x => x.oldValue !== x.newValue);
